import { maxTextLength, presence, ValidationRules } from '@mews-commander/legacy-form';
import { MAX_SMALL_INPUT_TEXT_LENGTH } from '@mews-commander/constants';
import { FIELD_NAMES, FormValues } from './Form';

type Constraints = {
    [K in keyof FormValues]?: ValidationRules;
};

export const getConstraints = (): Constraints => ({
    [FIELD_NAMES.VALUE]: {
        presence,
        length: maxTextLength(MAX_SMALL_INPUT_TEXT_LENGTH),
    },
});
